import React from "react";
import { ToastContainer } from "react-toastify";
import classes from "../../style/Style.module.css";
import {  ROUTE_DXTER_SCANNING } from "../../Routes";
import { useLocation, useNavigate } from "react-router-dom";

const BankProofSubmitted = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const { reason } = location.state || {};
  console.log(reason);

  const HandleSubmit = () => {
    Navigate(ROUTE_DXTER_SCANNING);
  };
  return (
    <div className={classes.FatcaFailed_Main_Container}>
      <div className={classes.Header}>
      </div>
      <div className={classes.BlankText_Screen_Container}>
        <p className={classes.Input_Heading_text}>{reason}</p>
        <p className={classes.Input_Heading_text_SubHeading}>
          You have submitted bank proof document for NSE Verification.
          <br />
          Please check back after some time..
        </p>
        <button className={classes.Submit_button} onClick={HandleSubmit}>
          Proceed to My Portfolio Details{" "}
        </button>
      </div>
      <ToastContainer />
      
    </div>
  );
};

export default BankProofSubmitted;
